navApp.default.factory('NavStateService', [
  function() {
    var blankCallout;
    blankCallout = {
      image: null,
      caption: ''
    };
    return {
      itemStates: {
        primary: {},
        tertiary: {}
      },
      levelItems: {
        primary: {},
        tertiary: {}
      },
      visibleLevel: {
        primary: 0,
        secondary: 0
      },
      currentCallout: {
        primary: blankCallout,
        tertiary: blankCallout
      },
      updateCallout: function(key, item) {
        this.currentCallout[key] = this.hasCallout(item) ? item.callout : blankCallout;
        return this.currentCallout[key].uid = item.uid;
      },
      emptyItemState: {
        open: false
      },
      setOpenState: function(key, id, isOpen) {
        return this.itemStates[key][id] = {
          open: isOpen
        };
      },
      closeAllByKey: function(key) {
        this.itemStates[key] = {};
        this.levelItems[key] = {};
        return this.setVisibleLevel(key, 0);
      },
      hasCallout: function(item) {
        return (_.size(item.callout)) > 0;
      },
      calloutSizer: function(key) {
        switch (this.getVisibleLevel(key)) {
          case 0:
          case 1:
          case 2:
            return 'large';
          case 4:
            return '';
        }
      },
      closeAll: function() {
        this.currentCallout = {
          primary: blankCallout,
          tertiary: blankCallout
        };
        return _.each(['primary', 'tertiary'], (function(_this) {
          return function(key) {
            return _this.closeAllByKey(key);
          };
        })(this));
      },
      setVisibleLevel: function(key, level) {
        return this.visibleLevel[key] = level;
      },
      getVisibleLevel: function(key) {
        if (this.visibleLevel[key]) {
          return this.visibleLevel[key];
        } else {
          return 0;
        }
      },
      showItem: function(key, id, level) {
        this.setVisibleLevel(key, level);
        this.levelItems[key][level] || (this.levelItems[key][level] = []);
        this.hideItemsForLevel(key, level);
        this.levelItems[key][level].push(id);
        return this.setOpenState(key, id, true);
      },
      hideItem: function(key, id, level) {
        this.hideItemsForLevel(key, level);
        return this.setOpenState(key, id, false, level);
      },
      idsForLevel: function(key, level) {
        return this.levelItems[key][level] || [];
      },
      hideItemsForLevel: function(key, level) {
        if (level !== void 0) {
          return _.each(this.idsForLevel(key, level), (function(_this) {
            return function(id) {
              return _this.hideItem(key, id);
            };
          })(this));
        }
      },
      itemState: function(key, id) {
        if (this.itemStates[key][id] != null) {
          return this.itemStates[key][id];
        } else {
          return this.emptyItemState;
        }
      },
      isOpen: function(key, id) {
        return this.itemState(key, id).open;
      }
    };
  }
]);
